import React, { FC, useState } from 'react'
import { Modal, Button } from '@pepper/ui'
import { Formik, Form } from 'formik'
import { promoCodeField } from '../schema'

import styles from './_.module.css'

import { getFieldComponent } from 'components/FormFields/FormFields'

interface Props {
  addPromoCodeModal: boolean
  onCancel: () => void
  promoCodesList: PromoCodes[]
  handleApplyPromoSubmit: (value: string) => void
  setSelectedPromoCode: (value: string) => void
  selectedPromoCode: string
  isLoading: boolean
  projectStructure?: SmeProjectStructure
  assignmentsList?: AssignmentListFormValues[]
  companyId: string
  accountType: ClientAccountType | null
  projectBrief?: ProjectDetailsFormValues
  brandGuidelines?: BrandGuidelines
  formFields?: {
    assignment: BackendFormField[]
    project: BackendFormField[]
    brandGuidelines: BackendFormField[]
    visualPreferencesFields: BackendFormField[]
  }
}

const PromoCode: FC<Props> = ({
  addPromoCodeModal,
  onCancel,
  promoCodesList,
  setSelectedPromoCode,
  selectedPromoCode,
  isLoading,
}) => {
  /* Use to copy the selected code in input field */
  const [tempPromoCode, setTempPromoCode] = useState(selectedPromoCode)
  const handleSelectedPromo = (code: string) => {
    setSelectedPromoCode(code)
    onCancel()
  }

  return (
    <div>
      <Modal
        closable
        title="Apply Promo Code"
        visible={addPromoCodeModal}
        onCancel={onCancel}
        footer={null}
      >
        <div>
          <p className={styles.promoDescription}>
            Apply a Promo Code to avail attractive discounts on Pepper Content!
          </p>
          <section className={styles.formSection}>
            <Formik
              initialValues={{ promo_code: tempPromoCode }}
              enableReinitialize={true}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={value => {
                handleSelectedPromo(value.promo_code)
              }}
            >
              {(props): React.ReactNode => {
                return (
                  <Form>
                    <section>
                      {promoCodeField.map(field => (
                        <div key={field.name} className={field.grid}>
                          {getFieldComponent({
                            type: field.type,
                            name: field.name,
                            label: field.label,
                            required: field.required,
                            actions: props,
                          })}
                        </div>
                      ))}
                    </section>
                    <section className={styles.applyBtn}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={isLoading}
                      >
                        Apply Code
                      </Button>
                    </section>
                    <section>
                      <div className={styles.availableOffersHeader}>
                        <span className={styles.headerTitle}>
                          All Available Offers
                        </span>
                      </div>
                      <div className={styles.promoCodeSection}>
                        {promoCodesList?.map((code, index) => (
                          <div key={index} className={styles.promoContainer}>
                            <p>{code.voucher?.title ?? ''}</p>
                            <div className={styles.promoCodeList}>
                              <div className={styles.promoCode}>
                                {code.voucher?.code}
                              </div>
                              <div>
                                <Button
                                  onClick={() => {
                                    props.resetForm()
                                    setTempPromoCode(code?.voucher?.code || '')
                                  }}
                                  type="link"
                                >
                                  Copy Code
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </Form>
                )
              }}
            </Formik>
          </section>
        </div>
      </Modal>
    </div>
  )
}

export default PromoCode
